import { ErrorReturn } from '../utils/ErrorReturn';
import { RPFileComponents } from './interfaces';

/**
 *
 * @param {string} xmlString - a string of XML
 * @param {RPFileComponents}policy - the XML deconstructed into usable building blocks
 */
export const generateRpXML = (xmlString: string, policy: RPFileComponents): ErrorReturn | string => {
  // DOMParser to go over XML policy
  // const parser = new DOMParser();

  // const xml = parser.parseFromString(xmlString, 'text/xml');

  // try {
  //   createXMLClaims(xml, policy.claims, parser);

  //   // createXMLClaimsTransformations(xml, policy.claimTransformations, parser);

  //   createXMLTechnicalProfiles(xml, policy.selfAssertedProfiles, policy.otherProfiles, parser);

  //   return new XMLSerializer().serializeToString(xml);
  // } catch (e: any) {
  //   return e;
  // }
  return xmlString;
};
